import useScrollAnimation from "@/hooks/useScrollAnimation";
import { bankingSolutionsData } from "@/mocks/homeData";

export default function BankingSection() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="banking" className="w-full py-16 md:py-24 bg-foreground-950">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-accent-500 uppercase tracking-widest">
            {bankingSolutionsData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-background-50 mt-3 mb-4 leading-tight">
            {bankingSolutionsData.headline}
          </h2>
          <p className="text-sm md:text-base text-background-300 leading-relaxed max-w-2xl mx-auto">
            {bankingSolutionsData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-5xl mx-auto mb-12">
          {bankingSolutionsData.solutions.map((solution) => (
            <div
              key={solution.title}
              className="group bg-foreground-900/40 rounded-xl p-5 md:p-6 border border-foreground-800/50 hover:border-accent-500/30 transition-all"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-accent-500/12 flex items-center justify-center shrink-0">
                  <i className={`${solution.icon} text-lg md:text-xl text-accent-400`} />
                </div>
                <div>
                  <h4 className="font-heading font-semibold text-sm md:text-base text-background-50 mb-1.5">
                    {solution.title}
                  </h4>
                  <p className="text-xs md:text-sm text-background-400 leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 ml-14 md:ml-[60px]">
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 bg-accent-500/8 px-2.5 py-1 rounded-full">
                  <i className="ri-bar-chart-2-line text-xs" />
                  {solution.scale}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => handleNavClick("#contact")}
            className="px-6 py-3 text-sm font-semibold rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            Speak With a Banking Technology Specialist
          </button>
        </div>

        <div className="mt-10 max-w-4xl mx-auto bg-foreground-900/30 rounded-xl p-5 md:p-6 border border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <h4 className="font-heading font-semibold text-sm md:text-base text-background-50 mb-1">
              See our recording platform in action
            </h4>
            <p className="text-xs md:text-sm text-background-400">
              Schedule a live demo. We&rsquo;ll walk you through the supervisor dashboard, search capabilities, and compliance reporting — no generic sales pitch.
            </p>
          </div>
          <button
            onClick={() => handleNavClick("#contact")}
            className="shrink-0 px-6 py-3 text-sm font-semibold rounded-md bg-background-50 text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Request a Demo
          </button>
        </div>
      </div>
    </section>
  );
}